import { render, staticRenderFns } from "./ScarletBody.vue?vue&type=template&id=ab835994&scoped=true"
import script from "./ScarletBody.vue?vue&type=script&lang=js"
export * from "./ScarletBody.vue?vue&type=script&lang=js"
import style0 from "./ScarletBody.vue?vue&type=style&index=0&id=ab835994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab835994",
  null
  
)

export default component.exports